import { createReducer } from '@reduxjs/toolkit';

import getCoOrders from '../../../thunks/coilovers/orders/getCoOrders';
import { removeCoOrder, setCoOrders } from '../../../actions/coilovers/orders/patchCoOrders';

const initialState = {
  loading: false,
  error: null,
  data: [],
  lastPage: undefined,
  currentPage: 1,
  total: 0
};

const getCoOrdersReducer = createReducer(initialState, {
  [getCoOrders.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCoOrders.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total
    }
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getCoOrders.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [removeCoOrder]: (state, { payload: id }) => ({
    ...state,
    data: [
      ...state.data.filter(({ _id: sourceId }) => id !== sourceId)
    ]
  }),
  [setCoOrders]: (state, { payload }) => {
    const { _id: updateId } = payload;
    // eslint-disable-next-line no-underscore-dangle
    const updateData = state?.data?.map((item) => (item._id === updateId ? payload : item));
    return {
      ...state,
      loading: false,
      error: payload,
      data: updateData
    };
  },
});

export default getCoOrdersReducer;
